import { useLocale, useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import ArticleCardsModule from '@/app/components/ArticleCardsModule';
import ArticleCardTag from '@/app/components/ArticleCardsModule/ArticleCardTag';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

import {
  metabolicHealthArticleCards,
  metabolicHealthArticleImageData,
} from './_data/metabolicHealthArticlesData';

const MetabolicHealthArticles = () => {
  const t = useTranslations();
  const locale = useLocale();
  const articleImage = metabolicHealthArticleImageData(
    getLocalePartialUrl(locale),
  );
  const articleCards = metabolicHealthArticleCards(getLocalePartialUrl(locale));

  const handleLinkClick = async (
    event: React.MouseEvent<HTMLAnchorElement>,
  ): Promise<void> => {
    const { href } = event.currentTarget;
    const { pathname } = new URL(href);

    await window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'read_more',
      location: 'activity and movement footer',
      path: pathname,
    });
  };

  return (
    <ArticleCardsModule
      articleImage={articleImage}
      articleCards={articleCards}
      data-cy="metabolic-health-articles"
      eyebrowText="pulse_blog_eyebrow"
      eyebrowTextColor="light"
      imageTag={() => (
        <ArticleCardTag tag="featured_article_tag" textColor="text-brown-500" />
      )}
      mobileSliderAriaLabels={[
        t('acitivy_article_one'),
        t('acitivy_article_two'),
        t('acitivy_article_three'),
      ]}
      onClick={handleLinkClick}
      swipeableDotsProps={{
        activeColor: 'sandstone-200',
        color: 'sandstone-500',
      }}
      wrapperClass="bg-mustard-350 text-mustard-700 relative"
    />
  );
};

export default MetabolicHealthArticles;
